import { QUESTION_SET_MAX_COUNT } from '../questionSets/constants';
import { AnswerSheetLetter, AttemptSubmissionReviewReason } from './enums';

/** Rows printed on the response sheet. */
export const ANSWER_SHEET_ROWS = QUESTION_SET_MAX_COUNT;

/** A question answered on the sheet offers at most one option per oval. */
export const ANSWER_SHEET_MAX_OPTIONS = Object.values(AnswerSheetLetter).length;

/** Reasons a reviewer settles by choosing the student. */
export const STUDENT_REVIEW_REASONS: readonly AttemptSubmissionReviewReason[] = [
  AttemptSubmissionReviewReason.StudentUnreadable,
  AttemptSubmissionReviewReason.StudentNotFound,
  AttemptSubmissionReviewReason.StudentAmbiguous,
];

/** Reasons a reviewer settles by choosing the set. */
export const SET_REVIEW_REASONS: readonly AttemptSubmissionReviewReason[] = [
  AttemptSubmissionReviewReason.SetUnreadable,
  AttemptSubmissionReviewReason.SetNotFound,
  AttemptSubmissionReviewReason.SetNotPublished,
  AttemptSubmissionReviewReason.SetUnsupported,
];

/** The longest name a sheet is recorded as reading. */
export const ATTEMPT_SUBMISSION_READ_NAME_MAX_LENGTH = 256;

/** The longest phone digits, or quiz code, a sheet is recorded as reading. */
export const ATTEMPT_SUBMISSION_READ_FIELD_MAX_LENGTH = 32;

/** The most submissions a listing returns. */
export const ATTEMPT_SUBMISSION_QUERY_LIMIT = 500;
